import { EnumUserTypes } from "@utils/constants";
import { JobSkillFormValues } from "../schema/jobForm.schema";

// skill/add identifies job skills with these values.
const JOB_SKILL_TYPE = 2; //job
const JOB_SKILL_USER_TYPE = EnumUserTypes.RECRUITER;

const toSkillFields = (skill: JobSkillFormValues) => ({
  title: skill.title.trim(),
  importance: skill.importance,
  requiredLevel: skill.requiredLevel,
  years: skill.years,
  lastUsed: skill.lastUsed,
  howWouldYouLikeToUseThisSkill: skill.howWouldYouLikeToUseThisSkill.trim(),
});

export const toAddSkillPayload = (skill: JobSkillFormValues, jobId: string) => ({
  jobId,
  type: JOB_SKILL_TYPE,
  userType: JOB_SKILL_USER_TYPE,
  ...toSkillFields(skill),
});

export const toUpdateSkillPayload = (skill: JobSkillFormValues) => ({
  id: skill._id,
  ...toSkillFields(skill),
});

// skill/lists response item -> form skill, used when resuming a draft.
export const fromSkill = (skill: any): JobSkillFormValues => ({
  _id: skill?._id,
  title: skill?.title ?? "",
  importance: skill?.importance ?? "",
  requiredLevel: skill?.requiredLevel ?? "",
  years: skill?.years ?? null,
  lastUsed: skill?.lastUsed ?? null,
  howWouldYouLikeToUseThisSkill: skill?.howWouldYouLikeToUseThisSkill ?? "",
  isSaved: true,
});
